export default __webpack_public_path__ + "static/media/aiden2.1d3f3e48.jpg";